import { connect } from 'react-redux';
import PromoCodeSignUp from './promo_code_sign_up';
import withPGTranslation from '../../config/withPGTranslation';

const mapStateProps = ({ application: { dynamicConfig } }) => ({ promo: dynamicConfig?.promo });

export default connect(mapStateProps)(withPGTranslation(PromoCodeSignUp));
